import React, { useCallback } from 'react';
import { DropDown } from '../shape.map';
import type { LineWidthDashOption } from '@/types/properties';
import type { DynamicComponentProps } from '@/types/commontypes';
import type { strokeDashTypes } from 'react-financial-charts';
import { DynamicSvg } from '../../DynamicSvg';
import styles from '../../../styles/global.module.css';

const lineStyles: strokeDashTypes[] = ['Solid', 'Dash', 'ShortDot'];
const widthList = [1, 2, 3, 4, 5];

const LineWidthDashOptionComponent: React.FC<DynamicComponentProps<LineWidthDashOption>> = ({
  label,
  value,
  onChange,
  isFromMiniToolbar,
}) => {
  const handleWidthChange = useCallback(
    (newStrokeWidth: number) => {
      if (newStrokeWidth !== value.strokeWidth) {
        onChange({ ...value, strokeWidth: newStrokeWidth });
      }
    },
    [value, onChange],
  );

  const handleDashChange = useCallback(
    (newDashType: strokeDashTypes) => {
      if (newDashType !== value.strokeDasharray) {
        onChange({ ...value, strokeDasharray: newDashType });
      }
    },
    [value, onChange],
  );

  const renderWidthItem = (item: number) => (
    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
      <div
        style={{
          borderTop: `${item}px solid var(--foreColor, #000)`,
          width: '24px',
          backgroundColor: 'transparent',
          margin: '5px 0',
        }}
      />
      <span>{`${item}px`}</span>
    </div>
  );

  const renderDashItem = (item: strokeDashTypes) => (
    <span style={{ fontWeight: 'bold', textTransform: 'capitalize' }}>
      {item && <DynamicSvg iconName={item} title={item} style={{ width: '20px', height: '20px', margin: '5px' }} />}
    </span>
  );

  const fromMiniToolbar = isFromMiniToolbar === undefined ? false : true;

  const dropdowns = (
    <>
      <DropDown
        value={value.strokeWidth}
        onChange={handleWidthChange}
        items={widthList}
        renderItem={renderWidthItem}
        title="Select Line Width"
        className={`${fromMiniToolbar ? 'border px-1 w-[75px] rounded' : ''}`}
      />
      <DropDown
        value={value.strokeDasharray}
        onChange={handleDashChange}
        items={lineStyles}
        renderItem={renderDashItem}
        title="Select Line Style"
        className={`${fromMiniToolbar ? 'border px-1 w-[40px] rounded' : ''}`}
      />
    </>
  );

  if (fromMiniToolbar) {
    return <div className="flex items-center flex-row space-x-2">{dropdowns}</div>;
  }

  return (
    <div className={styles.property_row}>
      {label && <label className={styles.property_label}>{label}</label>}
      <div className={styles.property_value}>{dropdowns}</div>
    </div>
  );
};

export default LineWidthDashOptionComponent;
